<template>
    <div class="project-checkup-form">

        <form @submit.prevent="submit">

            <div v-if="!isSubmitted">
                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_project_type') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_project_type') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-project-type-1" value="Immobilienprojekt (z.B. Bau, Entwicklung, Bestand)" v-model="projectType">
                    <label for="project-checkout-project-type-1">{{ translate('project_checkup_form_value_project_type_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-project-type-2" value="Unternehmensfinanzierung" v-model="projectType">
                    <label for="project-checkout-project-type-2">{{ translate('project_checkup_form_value_project_type_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-project-type-3" value="Anderes" v-model="projectType">
                    <label for="project-checkout-project-type-3">{{ translate('project_checkup_form_value_project_type_3') }}</label>
                </div>
                <div class="input-wrapper" v-if="hasOtherProjectType">
                    <input type="text" :placeholder="translate('project_checkup_form_placeholder_project_type_other')" v-model="projectTypeOther" required>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_required_capital') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_required_capital') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-required-capital-1" value="250.000 € - 500.000 €" v-model="requiredCapital">
                    <label for="project-checkout-required-capital-1">{{ translate('project_checkup_form_value_required_capital_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-required-capital-2" value="500.000 € - 1.000.000 €" v-model="requiredCapital">
                    <label for="project-checkout-required-capital-2">{{ translate('project_checkup_form_value_required_capital_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-required-capital-3" value="1.000.000 € - 2.500.000 €" v-model="requiredCapital">
                    <label for="project-checkout-required-capital-3">{{ translate('project_checkup_form_value_required_capital_3') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-required-capital-4" value="mehr als 2.500.000 €" v-model="requiredCapital">
                    <label for="project-checkout-required-capital-4">{{ translate('project_checkup_form_value_required_capital_4') }}</label>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_time_frame') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_time_frame') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-time-frame-1" value="Sofort" v-model="timeFrame">
                    <label for="project-checkout-time-frame-1">{{ translate('project_checkup_form_value_time_frame_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-time-frame-2" value="In 1-3 Monaten" v-model="timeFrame">
                    <label for="project-checkout-time-frame-2">{{ translate('project_checkup_form_value_time_frame_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-time-frame-3" value="Später als 3 Monate" v-model="timeFrame">
                    <label for="project-checkout-time-frame-3">{{ translate('project_checkup_form_value_time_frame_3') }}</label>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_company_type') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_company_type') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-company-type-1" value="Kapitalgesellschaft (z.B. GmbH, AG)" v-model="companyType">
                    <label for="project-checkout-company-type-1">{{ translate('project_checkup_form_value_company_type_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-company-type-2" value="Personengesellschaft / Einzelunternehmen" v-model="companyType">
                    <label for="project-checkout-company-type-2">{{ translate('project_checkup_form_value_company_type_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-company-type-3" value="In Gründung" v-model="companyType">
                    <label for="project-checkout-company-type-3">{{ translate('project_checkup_form_value_company_type_3') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-company-type-4" value="Andere" v-model="companyType">
                    <label for="project-checkout-company-type-4">{{ translate('project_checkup_form_value_company_type_4') }}</label>
                </div>
                <div class="input-wrapper" v-if="hasOtherCompanyType">
                    <input type="text" :placeholder="translate('project_checkup_form_placeholder_company_type_other')" v-model="companyTypeOther" required>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_contacts') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_contacts') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-contacts-1" value="Ja" v-model="contacts">
                    <label for="project-checkout-contacts-1">{{ translate('project_checkup_form_value_contacts_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-contacts-2" value="Nein" v-model="contacts">
                    <label for="project-checkout-contacts-2">{{ translate('project_checkup_form_value_contacts_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-contacts-3" value="In Vorbereitung" v-model="contacts">
                    <label for="project-checkout-contacts-3">{{ translate('project_checkup_form_value_contacts_3') }}</label>
                </div>
                <div class="input-wrapper select-input-wrapper" v-if="hasContacts">
                    <select v-model="contactsAmount">
                        <option value="<100">{{ translate('project_checkup_form_value_contacts_amount_1') }}</option>
                        <option value="100 bis 1.000">{{ translate('project_checkup_form_value_contacts_amount_2') }}</option>
                        <option value="1.000 bis 10.000">{{ translate('project_checkup_form_value_contacts_amount_3') }}</option>
                        <option value="mehr als 10.000 Kontakte">{{ translate('project_checkup_form_value_contacts_amount_4') }}</option>
                    </select>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_experience') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_experience') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-experience-1" value="Ja" v-model="experience">
                    <label for="project-checkout-experience-1">{{ translate('project_checkup_form_value_experience_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-experience-2" value="Nein" v-model="experience">
                    <label for="project-checkout-experience-2">{{ translate('project_checkup_form_value_experience_2') }}</label>
                </div>

                <div class="input-title">
                    <div>{{ translate('project_checkup_form_title_marketing') }}</div>
                </div>
                <div class="input-description">
                    {{ translate('project_checkup_form_description_marketing') }}
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-marketing-1" value="Ja, beides ist vorhanden und einsatzbereit" v-model="marketing">
                    <label for="project-checkout-marketing-1">{{ translate('project_checkup_form_value_marketing_1') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-marketing-2" value="Teilweise - wir haben entweder Bilder oder Texte" v-model="marketing">
                    <label for="project-checkout-marketing-2">{{ translate('project_checkup_form_value_marketing_2') }}</label>
                </div>
                <div class="input-wrapper radio-input-wrapper input-wrapper-small-spacing">
                    <input type="radio" id="project-checkout-marketing-3" value="Noch nicht - wir benötigen Unterstützung dabei" v-model="marketing">
                    <label for="project-checkout-marketing-3">{{ translate('project_checkup_form_value_marketing_3') }}</label>
                </div>

                <div class="project-checkup-result">
                    <hr>

                    <div class="input-title">
                        <div>{{ translate('project_checkup_form_title_result') }}</div>
                    </div>

                    <div class="input-description" v-if="projectCheckupFieldsFilled">
                        <div v-if="projectCheckupResult === 'green'" class="project-checkup-result-text">
                            <span class="project-checkup-result-icon">✅</span>
                            <span v-html="translate('project_checkup_form_result_green')"></span>
                        </div>
                        <div v-else-if="projectCheckupResult === 'yellow'" class="project-checkup-result-text">
                            <span class="project-checkup-result-icon">⚠️</span>
                            <span v-html="translate('project_checkup_form_result_yellow')"></span>
                        </div>
                        <div v-else class="project-checkup-result-text">
                            <span class="project-checkup-result-icon">❌</span>
                            <span v-html="translate('project_checkup_form_result_red')"></span>
                        </div>
                    </div>
                    <div class="input-description" v-else>
                        {{ translate('project_checkup_form_result_not_ready') }}
                    </div>
                </div>

                <!--
                    We can only hide this and not completely disable the
                    rendering because of the reCAPTCHA widget.
                -->
                <div class="project-checkup-submit" :class="{ 'd-none': !projectCheckupFieldsFilled }">
                    <div class="input-wrapper">
                        <input type="text" :placeholder="translate('first_name')" v-model="firstName" required>
                    </div>
                    <div class="input-wrapper">
                        <input type="text" :placeholder="translate('last_name')" v-model="lastName" required>
                    </div>
                    <div class="input-wrapper">
                        <input type="email" :placeholder="translate('email')" v-model="email" maxlength="255" required>
                    </div>
                    <div class="input-wrapper">
                        <input type="text" :placeholder="translate('phone')" v-model="phone" required>
                    </div>
                    <div class="input-wrapper checkbox-input-wrapper input-wrapper-large-spacing">
                        <input type="checkbox" id="newsletter-form-privacy-policy-checkbox" required v-model="privacyPolicyAccepted">
                        <label for="newsletter-form-privacy-policy-checkbox" v-html="translate('accept_privacy_policy')"></label>
                    </div>
                    <div class="input-wrapper checkbox-input-wrapper">
                        <input type="checkbox" id="newsletter-form-privacy-newsletter-checkbox" v-model="subscribeToNewsletter">
                        <label for="newsletter-form-privacy-newsletter-checkbox" v-html="translate('subscribe_to_newsletter_optional')"></label>
                    </div>

                    <br>

                    <div class="g-recaptcha" :data-sitekey="recaptchasitekey"></div>

                    <div class="input-wrapper input-wrapper-large-spacing">
                        <button type="submit" class="btn btn-alt btn-secondary double-arrow" :disabled="submitDisabled">{{ submitButtonText }}</button>
                    </div>
                </div>
            </div>

            <div class="message" :class="{ 'message-is-error': hasError, 'message-is-success': isSubmitted }" v-if="hasMessage" v-html="message"></div>

        </form>

    </div>
</template>

<script>
import Xhr from '../core/xhr';

export default {
    props: {
        recaptchasitekey: String
    },
    data () {
        return {
            projectType: '',
            projectTypeOther: '',
            requiredCapital: '',
            timeFrame: '',
            companyType: '',
            companyTypeOther: '',
            contacts: '',
            contactsAmount: '100 bis 1.000',
            experience: '',
            marketing: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            privacyPolicyAccepted: false,
            subscribeToNewsletter: false,
            isSubmitting: false,
            isSubmitted: false,
            hasError: false,
            message: ''
        };
    },

    computed: {
        hasOtherProjectType () {
            return this.projectType === 'Anderes';
        },
        hasOtherCompanyType () {
            return this.companyType === 'Andere';
        },
        hasContacts () {
            return this.contacts === 'Ja';
        },
        projectCheckupFieldsFilled () {
            return this.projectType.trim() !== ''
                && (
                    this.hasOtherProjectType
                        ? this.projectTypeOther.trim() !== ''
                        : true
                )
                && this.requiredCapital.trim() !== ''
                && this.timeFrame.trim() !== ''
                && this.companyType.trim() !== ''
                && (
                    this.hasOtherCompanyType
                        ? this.companyTypeOther.trim() !== ''
                        : true
                )
                && this.contacts.trim() !== ''
                && (
                    this.hasContacts
                        ? this.contactsAmount.trim() !== ''
                        : true
                )
                && this.experience.trim() !== ''
                && this.marketing.trim() !== '';
        },
        contactFieldsFilled () {
            return this.firstName.trim() !== ''
                && this.lastName.trim() !== ''
                && this.email.trim() !== ''
                && this.phone.trim() !== ''
                && this.privacyPolicyAccepted;
        },
        projectCheckupResult () {
            if (
                !this.hasContacts || (this.hasContacts && this.contactsAmount === '<100')
            ) {
                return 'red';
            }

            if (this.hasOtherCompanyType|| this.hasOtherProjectType) {
                return 'yellow';
            }

            return 'green';
        },
        requiredFieldsFilled () {
            return this.projectCheckupFieldsFilled && this.contactFieldsFilled;
        },
        submitDisabled () {
            return !this.requiredFieldsFilled
                || this.isSubmitting
                || this.isSubmitted;
        },
        submitButtonText () {
            return this.translate(`project_checkup_form_submit_button_${this.projectCheckupResult}`);
        },
        hasMessage () {
            return this.message.trim() !== ''
        }
    },

    methods: {
        submit () {
            if (this.submitDisabled) {
                return;
            }

            this.message = `<strong>${this.translate('project_checkup_sending')}</strong>`;
            this.hasError = false;
            this.isSubmitting = true;

            const projectCheckupResultMapping = {
                green: '✅ Sehr gute Voraussetzungen',
                yellow: '⚠️ Einige Punkte sollten besprochen werden',
                red: '❌ Aktuell scheint das Projekt nicht in das dagobertinvest-Modell zu passen'
            };

            const projectCheckupFields = [
                {
                    label: 'Projekttyp',
                    value: this.projectType
                },
                ...(this.hasOtherProjectType ? [{
                    label: 'Anderer Projekttyp (Freitext-Eingabe)',
                    value: this.projectTypeOther
                }] : []),
                {
                    label: 'Kapitalbedarf',
                    value: this.requiredCapital
                },
                {
                    label: 'Zeitrahmen',
                    value: this.timeFrame
                },
                {
                    label: 'Gesellschaftsform / Projekteinreicher',
                    value: this.companyType
                },
                ...(this.hasOtherCompanyType ? [{
                    label: 'Andere Gesellschaftsform (Freitext-Eingabe)',
                    value: this.companyTypeOther
                }] : []),
                {
                    label: 'Anlegerkontakte vorhanden',
                    value: this.contacts
                },
                ...(this.hasContacts ? [{
                    label: 'Anzahl der Kontakte',
                    value: this.contactsAmount
                }] : []),
                {
                    label: 'Erfahrung mit Crowdfunding o. Ä. vorhanden',
                    value: this.experience
                },
                {
                    label: 'Marketing-Material vorhanden',
                    value: this.marketing
                },
                {
                    label: 'Checkup-Ergebnis',
                    value: projectCheckupResultMapping[this.projectCheckupResult]
                }
            ];

            new Xhr({
                projectCheckupFields,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                privacyPolicyAccepted: this.privacyPolicyAccepted,
                subscribeToNewsletter: this.subscribeToNewsletter,
                grecaptcharesponse: document.getElementById('g-recaptcha-response').value
            }).post('/api/project-checkup/submit')
                .then(response => {
                    if (!response.success) {
                        this.hasError = true;
                        this.message = this.translate('project_checkup_error');
                        return;
                    }

                    this.isSubmitted = true;
                    this.message = this.translate('project_checkup_success');
                })
                .catch(err => {
                    this.hasError = true;
                    this.message = this.translate('project_checkup_error');
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }
}
</script>
